export default __webpack_public_path__ + "static/media/guide17.52dc4984.png";